import { OfficeToolsFormEventHandlersMap } from '../../../SingleGridForm/office-form/models/event-handler.model';
import { PREarnCode } from './PREarnCode';

export const OFFICE_TOOLS_FORM_EVENT_HANDLERS: Partial<OfficeToolsFormEventHandlersMap> = {
  PREarnCode,
};
